import { render, staticRenderFns } from "./TheRightAside.vue?vue&type=template&id=3941414d&"
import script from "./TheRightAside.vue?vue&type=script&lang=js&"
export * from "./TheRightAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports